import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { isEmpty, sortBy } from 'lodash';

import TextField from '@material-ui/core/TextField';
import AutoComplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';

import * as executiveSummaryActions from '../actions/executiveSummaryActions';

import * as classes from './EntitySelector.module.css';

const EntitySelector = ({
    activeNavCompany,
    activeClient,
    activeEquipmentSystemType,
    activeSite,
    attributes,
    clients,
    equipmentSystemTypes,
    equipmentTypes,
    fetchExecutiveSummaryEquipmentSystemTypes,
    fetchExecutiveSummarySites,
    navClients,
    navClientsMeta,
    setActiveClient,
    setActiveEquipmentSystemType,
    setActiveSite,
    sites,
    setClients,
    setEquipmentSystemTypes,
    setSites,
    setZoomSite,
    systemTypes,
    targetNavCompany,
    ...props
}) => {
    const [selectedClient, setSelectedClient] = useState('');
    const [selectedSite, setSelectedSite] = useState('');
    const [selectedEquipmentSystemType, setSelectedEquipmentSystemType] = useState('');
    const [siteLoading, setSiteLoading] = useState(false);

    useEffect(() => {
        setSelectedSite(activeSite);
    }, [activeSite]);

    useEffect(() => {
        setSelectedClient(activeClient);
    }, [activeClient]);

    useEffect(() => {
        if (!isEmpty(navClients) && targetNavCompany.id === activeNavCompany.id) setClients(navClients);
    }, [navClients]);

    useEffect(() => {
        const init = () => {
            const equipmentTypeArray = [...equipmentTypes.data];
            const systemTypeArray = [...systemTypes.data];
            equipmentTypeArray.map(item => item.grouping = 'Equipment Type');
            systemTypeArray.map(item => item.grouping = 'System Type');

            const payload = [...equipmentTypeArray, ...systemTypeArray];
            setEquipmentSystemTypes(payload);
        };
        
        if (!isEmpty(equipmentTypes.data) && !isEmpty(systemTypes.data)) init();
    }, [equipmentTypes, systemTypes]);

    const handleChangeClient = async (event, value) => {
        if (value) {
            setActiveSite({});
            setSelectedSite({});

            setSiteLoading(true);
            setSelectedClient(value);
            setActiveClient(value);
            const siteList = await fetchExecutiveSummarySites(value.id);
            setSites(siteList);
            setSiteLoading(false);
        } else {
            setSelectedClient(value);
            setActiveClient(value);
            setZoomSite(value);
            setSites([]);
        }
    };

    const handleChangeSite = async (event, value) => {
        setSelectedSite(value);
        setActiveSite(value);

        if (!value) {
            setZoomSite(value);
        }
    };

    const handleChangeEquipmentSystemType = (event, value) => {
        setActiveEquipmentSystemType(value);
        setSelectedEquipmentSystemType(value || '');
    };

    return (
        <div className={classes.Container}>
            <span className={classes.ClientContainer}>
                <AutoComplete
                    className={classes.ClientSelector}
                    id="clientId"
                    name="clientId"
                    options={sortBy(clients, 'name')}
                    getOptionLabel={(option) => option.name || 'All'}
                    getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                    value={selectedClient}
                    onChange={(event, value) => handleChangeClient(event, value)}
                    size="small"
                    required
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={'Select client'}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {isEmpty(navClientsMeta) ? <CircularProgress color="inherit" size={15} /> : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />}
                />
            </span>
            <span className={classes.ClientContainer}>
                <AutoComplete
                    className={classes.SiteSelector}
                    id="siteId"
                    disabled={isEmpty(selectedClient)}
                    name="siteId"
                    options={sortBy(sites, 'name')}
                    getOptionLabel={(option) => option.name || 'All' }
                    getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                    value={selectedSite}
                    onChange={(event, value) => handleChangeSite(event, value)}
                    size="small"
                    required
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={'Select site'}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {siteLoading ? <CircularProgress color="inherit" size={15} /> : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />}
                />
            </span>
            <AutoComplete
                className={classes.EquipmentSystemTypeSelector}
                id="equipmentSystemType"
                name="equipmentSystemType"
                options={sortBy(equipmentSystemTypes, ['grouping', 'name'])}
                groupBy={(option) => option.grouping}
                getOptionLabel={(option) => option.name || 'All' }
                getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                value={selectedEquipmentSystemType}
                onChange={(event, value) => handleChangeEquipmentSystemType(event, value)}
                size="small"
                required
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label={'Select equipment/system type'}
                        InputProps={{
                            ...params.InputProps,
                        }}
                    />}
            />
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavClient:  state.bob.activeNavClient,
        activeNavCompany: state.bob.activeNavCompany,
        attributes:       state.attributeManagement.attributes,
        equipmentTypes:   state.equipmentTypes,
        navClients:       state.bob.navClients,
        navClientsMeta:   state.bob.navClientsMeta,
        systemTypes:      state.systemTypes,
        targetNavCompany: state.bob.targetNavCompany
    };
};

const mapDispatchToProps = {
    ...executiveSummaryActions
};

export default connect(mapStateToProps, mapDispatchToProps)(EntitySelector);
